import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";

export default function BarcodeChangeDialog({ productId, current, onClose, onDone }) {
  const [barcode, setBarcode] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/identifiers/products/${productId}/change-barcode`, { barcode, reason });
      toast.success(`Barkod değiştirildi: ${data.old} → ${data.barcode} (eski barkod emekli, dolu kalır)`);
      onDone(data.barcode);
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="barcode-change-dialog">
        <DialogHeader><DialogTitle>Barkodu Değiştir (Süper Yönetici)</DialogTitle>
          <DialogDescription>Mevcut {current} emekli olur ve kalıcı olarak dolu kalır; kod yeni GTIN'e bağlanır. İşlem denetim kaydına yazılır.</DialogDescription></DialogHeader>
        <input value={barcode} onChange={(e) => setBarcode(e.target.value.replace(/\D/g, "").slice(0, 14))} placeholder="Yeni GTIN (8/12/13/14 hane)" className="h-9 rounded border px-2 font-mono" data-testid="barcode-change-new" />
        <textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Gerekçe (zorunlu)" className="min-h-[70px] rounded border p-2 text-sm" data-testid="barcode-change-reason" />
        <DialogFooter><Button variant="outline" onClick={onClose}>Vazgeç</Button>
          <Button disabled={busy || barcode.length < 8 || reason.trim().length < 5} onClick={save} data-testid="barcode-change-save">Değiştir</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
